import type { FieldsOption } from "@stripe/stripe-js";
import { useMemo } from "react";

export const usePaymentElementFields = (): FieldsOption =>
  useMemo(
    () => ({
      billingDetails: {
        // We never let the Payment Element show the name field because we rely on:
        // - The name field from the Address Element;
        // - or the name field in our form.
        name: "never",
        // We never let the Payment Element show the email field because we rely on
        // the email field in our form.
        email: "never",
        // We let the Payment Element decide when to show the address fields it requires to
        // allow the community members to complete their purchase.
        //
        // The Payment Element won't show any address fields if:
        // - The community member is logged in and has already provided the fields it requires;
        // - or the Address Element is rendered in the page.
        address: "auto",
      },
    }),
    [],
  );
